module.exports = __webpack_public_path__ + "img/img91.9b1ebd16.svg";